export default __webpack_public_path__ + "static/media/img-ventana-a+b.5666436f.png";